import { graphql } from "../gql";

export const getThreadQueryDoc = graphql(`
  query getThread($id: ID!, $messagesArgs: MessagesArgs) {
    thread(id: $id) {
      ...ThreadFragment
      messagesConnection(args: $messagesArgs) {
        totalCount
        pageInfo {
          ...PageInfoFragment
        }
        nodes {
          ...MessageFragment
          response {
            ...PromptResponseFragment
          }
          feedback {
            ...PromptFeedbackFragment
          }
          citations {
            ...InlineCitationsFragment
          }
        }
      }
    }
  }
`);
